import { render, staticRenderFns } from "./jumbotron.vue?vue&type=template&id=06240f0b"
import script from "./jumbotron.vue?vue&type=script&lang=js"
export * from "./jumbotron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports